// extracted by mini-css-extract-plugin
export default {"messageBody":"OrganizationValidation_messageBody__mMuev","breathing":"OrganizationValidation_breathing__DM26l"};